import {register} from "swiper/element/bundle";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'app-swiper',
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SwiperComponent implements AfterViewInit {
  @ViewChild('swiperContainer', {static: true})
  swiperContainer!: ElementRef;

  @Input()
  swiperId = '';
  @Input()
  paginationType = 'fraction'
  @Input()
  navigation = false;
  @Input()
  hideNavigationOnMobile = false;
  @Input()
  autoplay = true;
  @Input()
  showStatus = false;

  currentSlide = 1;
  totalSlides = 1;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    register();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const params = {
      // Swiper Element 버전에 따라 이벤트 접두사 기본값이 다르므로 명시적으로 고정한다.
      // 아래 swiperslidechange 리스너가 슬라이드 이동을 항상 감지할 수 있다.
      eventsPrefix: 'swiper',
      injectStyles: [
        '.swiper-pagination-bullet {width: 8px !important;height: 8px !important;background: #eaeaea !important; opacity: 1 !important;}',
        '.swiper-pagination-bullet-active {width: 8px !important;height: 8px !important;background: #0b57d0 !important;opacity: 1 !important;}',
        '.swiper-button-next, .swiper-button-prev {color: #9aa3b2 !important;opacity: .78;transition: color .2s ease, opacity .2s ease;}',
        '.swiper-button-next:hover, .swiper-button-prev:hover {color: #6f7785 !important;opacity: 1;}',
        '.swiper-pagination.swiper-pagination-hidden {opacity: .1}',
        ...(this.hideNavigationOnMobile ? [
          '@media (max-width: 599px) {.swiper-button-next, .swiper-button-prev {display: none !important;}}'
        ] : [])
      ],
      autoplay: !this.autoplay || prefersReducedMotion ? false : {
        delay: 30000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
      },
      threshold: 30,
      grabCursor: true,
      navigation: this.navigation,
      pagination: {
        type: this.paginationType,
        clickable: true,
        hideOnClick: false,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: '이전 배너',
        nextSlideMessage: '다음 배너',
        firstSlideMessage: '첫 번째 배너입니다',
        lastSlideMessage: '마지막 배너입니다',
        paginationBulletMessage: '{{index}}번째 배너 보기'
      }
    };

    const container = this.swiperContainer.nativeElement;
    this.totalSlides = container.querySelectorAll('swiper-slide').length || 1;
    container.addEventListener('swiperslidechange', (event: CustomEvent) => {
      const swiper = event.detail?.[0];
      this.currentSlide = (swiper?.realIndex ?? swiper?.activeIndex ?? 0) + 1;
      this.changeDetectorRef.detectChanges();
    });
    Object.assign(container, params);
    container.initialize();
    // projected slide 개수는 뷰 생성 후 확정되므로 현재 뷰에 즉시 반영한다.
    this.changeDetectorRef.detectChanges();
  }
}
